import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import { addDepartment, updateDepartment } from "../../services/departmentService";
import toast from "react-hot-toast";

const DepartmentModal = ({
  filterDepartment,
  departmentID,
  companyID,
  setRenderState,
  renderState,
  deletingDepartmentId,
  handleConfirmDelete,
  handleCancelDelete,
  showDeleteModal,
}) => {
  const [departmentName, setDepartmentName] = useState("");
  const [departmentError, setDepartmentError] = useState(false);

  // Populate edit modal with existing department name
  useEffect(() => {
    if (departmentID && filterDepartment && filterDepartment.length > 0) {
      setDepartmentName(filterDepartment[0]?.department || "");
    }
  }, [departmentID, filterDepartment]);

  // Reset state when Add Department modal is opened
  useEffect(() => {
    const addModal = document.getElementById("add_department");
    const handleAddModalOpen = () => {
      setDepartmentName("");
      setDepartmentError(false);
    };

    if (addModal) {
      addModal.addEventListener("show.bs.modal", handleAddModalOpen);
      return () => {
        addModal.removeEventListener("show.bs.modal", handleAddModalOpen);
      };
    }
  }, []);

  // Reset state when Edit Department modal is closed
  useEffect(() => {
    const editModal = document.getElementById("edit_department");
    const handleEditModalHide = () => {
      setDepartmentName("");
      setDepartmentError(false);
    };

    if (editModal) {
      editModal.addEventListener("hidden.bs.modal", handleEditModalHide);
      return () => {
        editModal.removeEventListener("hidden.bs.modal", handleEditModalHide);
      };
    }
  }, []);

  const departmentSubmitHandler = async (e) => {
    e.preventDefault();
    if (!departmentName) {
      setDepartmentError(true);
      return;
    }
    setDepartmentError(false);
    try {
      const response = await updateDepartment(departmentID, companyID, {
        deparetmentName: departmentName,
      });
      if (response?.success) {
        toast.success("Department updated successfully");
        setRenderState(!renderState);
        setDepartmentName("");
        document.getElementById("edit_department")?.querySelector('[data-bs-dismiss="modal"]')?.click();
      }
    } catch (err) {
      console.log("error", err);
      toast.error(err.response?.data?.message || "Failed to update department");
    }
  };

  const addDepartmentHandler = async (e) => {
    e.preventDefault();
    if (!departmentName) {
      setDepartmentError(true);
      return;
    }
    setDepartmentError(false);
    try {
      const response = await addDepartment(companyID, {
        deparetmentName: departmentName,
      });
      if (response?.success) {
        toast.success("Department added successfully");
        setRenderState(!renderState);
        setDepartmentName("");
        document.getElementById("add_department")?.querySelector('[data-bs-dismiss="modal"]')?.click();
      }
    } catch (err) {
      console.log("error", err);
      toast.error(err.response?.data?.message || "Failed to add department");
    }
  };
  return (
    <>
      {/* Add Department Modal */}
      <div
        id="add_department"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Department</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={addDepartmentHandler}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Department Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={departmentName}
                    onChange={(e) => setDepartmentName(e.target.value)}
                  />
                  {departmentError && (
                    <span className="text-danger">
                      *Please Enter Department Name !
                    </span>
                  )}
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Department Modal */}
      {/* Edit Department Modal */}
      <div
        id="edit_department"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Department</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={departmentSubmitHandler}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Department Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={departmentName}
                    onChange={(e) => setDepartmentName(e.target.value)}
                  />
                  {departmentError && (
                    <span className="text-danger">
                      *Please Enter Department Name !
                    </span>
                  )}
                  {/* {departmentError && <span className="text-danger">*Please Enter Department Name !</span>} */}
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Department Modal */}
      
      {/* Delete Department Modal */}
      <div
        id="delete_department"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>Delete Department</h3>
                <p>Are you sure you want to delete this department?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary continue-btn w-100"
                      onClick={handleConfirmDelete}
                      data-bs-dismiss="modal"
                    >
                      Delete
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary cancel-btn w-100"
                      onClick={handleCancelDelete}
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Department Modal */}
    </>
  );
};

export default DepartmentModal;
